import React from "react";
import classNames from "classnames";
import css from "./RightSide.module.scss";

/**
 * Right Side
 */
const RightSide = ({children}) => (
  <div
    data-testid={"EntityListItem-RightSide"}
    className={classNames(css.rightSide, "pl-2")}>
    {children}
  </div>
);

export default RightSide;
